import src from "IMAGE";
export default { src, width: 1279, height: 374, blurWidth: 0, blurHeight: 0};
